import { number } from 'prop-types';
import React from 'react';

import ShortCurrencyFormat from '../../generic/ShortCurrencyFormat';
import InfoTooltip from '../../generic/Tooltip/InfoTooltip';
import HELP_TEXTS from '../help-texts';

function LaneBudgets({
  openBudget,
  expectedRevenue,
  netClientBudgetExternal,
  coInvest,
  freeService,
  wkzBudget,
  spendableBudget,
}) {
  return (
    <div className="py-1 text-left text-muted small ">
      <div className="ml-2 mr-2">
        Open Budget: <ShortCurrencyFormat value={openBudget} />{' '}
        <InfoTooltip target="open-budget" className="text-muted">
          {HELP_TEXTS.info.openBudget}
        </InfoTooltip>
      </div>
      <div className="ml-2 mr-2">
        Expected Revenue: <ShortCurrencyFormat value={expectedRevenue} />{' '}
        <InfoTooltip target="expected-revenue" className="text-muted">
          {HELP_TEXTS.info.expectedRevenue}
        </InfoTooltip>
      </div>
      <div className="ml-2 mr-2">
        Co Invest: <ShortCurrencyFormat value={coInvest} />
        <InfoTooltip target="co-invest" className="text-muted">
          {HELP_TEXTS.info.coInvest}
        </InfoTooltip>
      </div>
      <div className="ml-2 mr-2">
        Free Service: <ShortCurrencyFormat value={freeService} />{' '}
        <InfoTooltip target="free-service" className="text-muted">
          {HELP_TEXTS.info.freeService}
        </InfoTooltip>
      </div>
      <div className="ml-2 mr-2">
        Net Client Budget External:{' '}
        <ShortCurrencyFormat value={netClientBudgetExternal} />{' '}
        <InfoTooltip target="net-client-budget-external" className="text-muted">
          {HELP_TEXTS.info.netClientBudgetExternal}
        </InfoTooltip>
      </div>
      <div className="ml-2 mr-2">
        Net Client Budget WKZ: <ShortCurrencyFormat value={wkzBudget} />{' '}
        <InfoTooltip target="wkz-budget" className="text-muted">
          {HELP_TEXTS.info.wkzBudget}
        </InfoTooltip>
      </div>
      <div className="ml-2 mr-2">
        Spendable Budget: <ShortCurrencyFormat value={spendableBudget} />{' '}
        <InfoTooltip target="spendable-budget" className="text-muted">
          {HELP_TEXTS.info.spendableBudget}
        </InfoTooltip>
      </div>
    </div>
  );
}

LaneBudgets.propTypes = {
  openBudget: number,
  expectedRevenue: number,
  netClientBudgetExternal: number,
  coInvest: number,
  freeService: number,
  wkzBudget: number,
  spendableBudget: number,
};

LaneBudgets.defaultProps = {
  openBudget: 0,
  expectedRevenue: 0,
  netClientBudgetExternal: 0,
  coInvest: 0,
  freeService: 0,
  wkzBudget: 0,
  spendableBudget: 0,
};

export default LaneBudgets;
